<template>
  <div>
    <DxNumberBox
      :value="value"
      :format="getDecimalFormatByName(format).Format"
      :disabled="true"
      v-bind:style="{
        width: (Math.round(value).toString().length + length) * 8 + 2 + 'px',
      }"
    />
  </div>
</template>

<script>
import BaseViewMixin from "../_mixins/base.view";
export default {
  props: ["value", "format", "length"],

  mixins: [BaseViewMixin],
  created() {},
};
</script>

<style lang="scss"></style>
